/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import './HotelDetails.scss';

export default function HotelDetailsOverview({ hotelDetails, aboutRef }) {
  const [expanded, setExpanded] = useState(true);
  const [showToggle, setShowToggle] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight =
        parseFloat(getComputedStyle(textRef.current).lineHeight) || 22;
      const maxHeight = lineHeight * 3;
      setShowToggle(textRef.current.scrollHeight > maxHeight + 4);
    }
  }, [hotelDetails?.description]);

  return (
    <section ref={aboutRef} id="about" className="hdp-section">
      <h3 className="hdp-section__title">About</h3>
      <div
        ref={textRef}
        className={`hdp-about__text${
          expanded ? '' : ' hdp-about__text--collapsed'
        }`}
        dangerouslySetInnerHTML={{
          __html: hotelDetails?.description,
        }}
      />
    </section>
  );
}
